export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/0c7f90dcab4574f291a5b93f31621815.svg";